import { AlphaTIcon } from './AlphaTIcon';

/**
 * author: GreenTurtwig
 * id DEAF6AD9-9AB9-4B59-B47D-830357A4B665
 * name alpha-t
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-t.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetTIcon = AlphaTIcon;
export default AlphabetTIcon